import { Controller } from 'stimulus'

export default class extends Controller {

  static targets = ['video', 'iframe', 'playButton', 'poster', 'controls']

  toggle() {
    if (this.videoTarget.paused) {
      this.videoTarget.play()
      this.controlsTarget.style.opacity = '0'
    } else {
      this.controlsTarget.style.opacity = '1'
      this.videoTarget.pause()
    }
  }
}
